'use client';
import Button from '@/app/_components/buttons/Button';
import Image from 'next/image';
import { useRouter } from 'next/navigation';

type ZocBotStateProps = {
  botImage?: string;
  showHomepageButton?: boolean;
  textTitle?: string;
  pageTitle?: string;
  text?: string;
  sideArea?: {
    left?: any;
    right?: { title: string; text: string };
  };
};

const ZocBotState = ({ ...props }: ZocBotStateProps) => {
  const router = useRouter();
  const goToHome = () => {
    router.push(`/`);
  };
  return (
    <>
      {/* PAGE TITLE */}
      {/* <div className="p-4">
        {props.pageTitle && (
          <h2 className="text-lg font-sans font-bold">{props.pageTitle}</h2>
        )}
      </div>
      {/* LEFT SIDE */}
      {props.sideArea?.left && <>{props.sideArea.left}</>}

      <div className="w-full block items-center justify-center lg:flex">
        <div className="mx-auto lg:mx-0 grow flex flex-col items-center">
          {/* BOT IMAGE */}
          {props.botImage && (
            <Image
              src={props.botImage}
              priority={false}
              alt="empty"
              width="300"
              height="300"
              className="mb-7"
            />
          )}
          {/* TEXT TITLE */}
          {props.textTitle && (
            <h3 className="text-5xl font-sans font-extrabold pb-2 italic text-center text-gradient">
              {props.textTitle}
            </h3>
          )}
          {/* TEXT */}
          {props.text && (
            <p className="mt-4 text-lg mb-12 text-center max-w-[650px] px-6">
              {props.text}
            </p>
          )}
          {props.showHomepageButton && (
            <Button onClick={goToHome} label="Homepage" variant="primary" />
          )}
        </div>
      </div>

      {/* RIGHT SIDE */}
      {props.sideArea?.right && <>{props.sideArea.right}</>}
    </>
  );
};

export { ZocBotState };
